import React, { useCallback } from 'react';

import {
  offersHubPayloadDownloadFilename,
  serializeOffersHubPayload,
} from '~/utils/societePayloadBuilder/offersHub/buildPayload';
import type { OffersHubPayloadBuilderState } from '~/utils/societePayloadBuilder/offersHub/types';

import PayloadBuilderJsonActions from '../JsonActions';

interface OffersHubPayloadActionsProps {
  state: OffersHubPayloadBuilderState;
  isValid: boolean;
  fullWidth?: boolean;
}

function getOffersHubPayloadFilename() {
  return offersHubPayloadDownloadFilename();
}

export default function OffersHubPayloadActions({ state, isValid, fullWidth = false }: OffersHubPayloadActionsProps) {
  const isOffersHubPayloadValid = useCallback(() => isValid, [isValid]);

  return (
    <PayloadBuilderJsonActions
      state={state}
      fullWidth={fullWidth}
      isValid={isOffersHubPayloadValid}
      serialize={serializeOffersHubPayload}
      getFilename={getOffersHubPayloadFilename}
      disabledTitle="Fix validation errors before copying or downloading"
      copyLabel="Copy JSON"
      copySuccessMessage="Offers Hub payload copied to clipboard"
      copyErrorMessage="Failed to copy Offers Hub payload"
    />
  );
}
